exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".XVValidation .gritter-warning a[data-v-4254fbb4]{color:#000}", ""]);

// exports
